import React from 'react';

interface GalleryViewProps {
  capturedMedia: string | null;
  mediaType: 'photo' | 'video' | null;
  selectedFile: File | null;
  onSelect: () => void;
  formatFileSize: (bytes: number) => string;
}

const GalleryView: React.FC<GalleryViewProps> = ({
  capturedMedia,
  mediaType,
  selectedFile,
  onSelect,
  formatFileSize,
}) => {
  if (!capturedMedia) {
    return (
      <div className="relative w-full h-full flex items-center justify-center bg-black">
        <button
          onClick={onSelect}
          className="bg-blue-500 hover:bg-blue-600 text-white px-8 py-4 rounded-full text-lg font-medium shadow-lg transition-all transform hover:scale-105"
        >
          انتخاب از گالری
        </button>
      </div>
    );
  }

  return (
    <div className="relative w-full h-full bg-black">
      {mediaType === 'video' ? (
        <video
          src={capturedMedia}
          className="w-full h-full object-contain"
          controls
          muted
          playsInline
        />
      ) : (
        <img
          src={capturedMedia}
          alt="Selected"
          className="w-full h-full object-contain"
        />
      )}

      {/* File info display */}
      {selectedFile && (
        <div className="absolute top-20 left-4 bg-black bg-opacity-70 backdrop-blur-md text-white px-3 py-2 rounded-lg text-sm">
          {formatFileSize(selectedFile.size)}
        </div>
      )}
    </div>
  );
};

export default GalleryView;

